/**
 * Scene/act options for the I2V form. Each option maps to a
 * `lora_preference` value understood by the backend `lora-selector.ts`.
 *
 * "auto" means: don't pin a LoRA — let backend keyword routing choose
 * one based on the prompt (and the cum-priority override always wins
 * regardless of what's selected here).
 */
export interface ScenePreset {
  id: string;
  label: string;
  /** Maps to backend `lora-selector.ts` LoraConfig.id (or "auto"). */
  loraPreference: string;
}

export const SCENE_PRESETS: ScenePreset[] = [
  { id: "auto", label: "Auto", loraPreference: "auto" },
  { id: "posing_nude", label: "Posing Nude", loraPreference: "posing_nude" },
  { id: "twerking", label: "Twerking", loraPreference: "twerking" },
  { id: "kissing", label: "French Kiss", loraPreference: "kissing" },
  { id: "fingering", label: "Fingering", loraPreference: "fingering" },
  { id: "doggy", label: "Doggy Style", loraPreference: "dreamly" },
  { id: "missionary", label: "Missionary", loraPreference: "dreamly" },
  { id: "cowgirl_reverse", label: "Reverse Cowgirl", loraPreference: "cowgirl_reverse" },
  { id: "assertive_cowgirl", label: "Cowgirl (Hip Slammin')", loraPreference: "assertive_cowgirl" },
  { id: "pov_riding", label: "POV From Below", loraPreference: "pov_riding" },
  { id: "anal_reverse_cowgirl", label: "Anal Reverse Cowgirl", loraPreference: "anal_reverse_cowgirl" },
  { id: "sensual_bj", label: "Sensual Blowjob", loraPreference: "sensual_bj" },
  { id: "deepthroat", label: "Deepthroat", loraPreference: "deepthroat" },
  { id: "edible_anus", label: "Anus Close-Up", loraPreference: "edible_anus" },
  { id: "cum_facial", label: "Cum Facial", loraPreference: "cum_facial" },
];

export const DEFAULT_SCENE_ID = "auto";
